import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
import CustomFooter from '../../login/CustomFooter'
//import SubjectHistogram from '../../admin/SubjectHistogram'
//import SupportPieChartTiers from '../../admin/SupportPieChartTiers'
//import PersonAvatar from '../../customcomponents/PersonAvatar'
//import Empty from '../../customcomponents/Empty'
//import { getIDFromURL } from '../.././Util'
import { chunkArray, getAssessmentDisplayName, getQueryStringParam, getColorGradient } from '../.././Util'
//import { db } from '../../firebase/Firebase'
//import ColType from '../.././Types'
import { Layout, Icon, Button, Modal } from 'antd'
//import PacingGuideAssessment from './PacingGuideAssessment'
import DocumentDelegator from '../../edviz/EdvizDelegator'
import ReactToPrint from "react-to-print"
import HTMLAssessmentViewer from '../html/components/HTMLAssessmentViewer'
import StudentResource from './StudentResource'
const { Content } = Layout
//var moment = require('moment')


class PrintableAssessmentModal extends Component {
    state = {
        modalVisible: false,
    }

    showModal = () => {
        this.setState({
            modalVisible: true,
        })
    }

    hideModal = () => {
        this.setState({
            modalVisible: false,
        })
    }

    render() {
        let assessment = this.props.assessment

        return (
            <div>
                <div>
                    <Button
                        type='primary'
                        className="lg-btn"
                        onClick={(e) => {
                            this.showModal();
                        }}
                    >
                        <Icon type="printer" />
                        {this.props.printButtonText ? this.props.printButtonText : 'Print quiz'}
                    </Button>
                </div>
                <Modal
                    title={"Print quiz"}
                    visible={this.state.modalVisible}
                    onCancel={this.hideModal}
                    footer={null}
                    width={850}
                >
                    <div>
                        {!assessment ? '' :
                            <div className={assessment.hasOwnProperty('htmlQuiz') ?
                                'w-850' : 'w-800 background-fully-transparent'}>
                                <div>
                                    {!assessment.hasOwnProperty('htmlQuiz') ?
                                        <div className='flex w-100 mb-3'>
                                            <ReactToPrint
                                                trigger={() =>
                                                    <Button
                                                        size={'large'}
                                                        type='primary'
                                                        className="lg-btn mr-1"
                                                    >
                                                        <Icon type="printer" />
                                                        Print quiz
                                                    </Button>
                                                }
                                                content={() => this.componentRef}
                                            />
                                        </div> : ''}
                                </div>

                                <div ref={el => (this.componentRef = el)}>
                                    {assessment.hasOwnProperty('htmlQuiz') ?
                                        <div>
                                            <HTMLAssessmentViewer
                                                htmlContent={assessment.htmlQuiz}
                                                quiz={assessment}
                                                teacherBaseProps={this.props.teacherBaseProps}
                                                title={assessment.assessmentTitle}
                                                maxWidth="850px"
                                            />
                                        </div> :
                                        assessment.hasOwnProperty('version') && assessment.version === '3.0' ?
                                            <div className='w-800 m-lr-auto'>
                                                <StudentResource
                                                    htmlSource={assessment.docs}
                                                    disableSplitView={true} />
                                            </div> :
                                            assessment && !assessment.hasOwnProperty('htmlQuiz') && assessment.docs.map((lessonPlanItem, idx) => {
                                                let currentQuestion = lessonPlanItem

                                                return <div key={'assessment-idx-' + idx}>
                                                    <div className='print-hide'>
                                                        <div className='font-black font-20 ant-shadow br-15 p-4 mb-50'>
                                                            <div className='font-24 mb-2 font-bold'>Question {idx + 1}</div>
                                                            <DocumentDelegator
                                                                document={lessonPlanItem}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='print-show'>
                                                        <div className='font-black font-20 mb-50 mt-4 page-break-inside-avoid'>
                                                            <div className='font-20 mb-2 font-bold'>Question {idx + 1}</div>
                                                            <div className='mb-1 font-20'>
                                                                <DocumentDelegator
                                                                    document={{
                                                                        components: currentQuestion.components[0].question,
                                                                        assessment: assessment,
                                                                        metadata: currentQuestion.metadata
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className='w-100 mt-2 page-break-inside-avoid'>
                                                                {currentQuestion.components[0].answers.map((choice, choiceIndex) => {
                                                                    let choiceLetter = 'A'
                                                                    const choiceIndexPlusOne = choiceIndex + 1
                                                                    if (choiceIndexPlusOne === 2) {
                                                                        choiceLetter = 'B'
                                                                    } else if (choiceIndexPlusOne === 3) {
                                                                        choiceLetter = 'C'
                                                                    } else if (choiceIndexPlusOne === 4) {
                                                                        choiceLetter = 'D'
                                                                    }
                                                                    return <div className='flex w-100 mt-1'
                                                                        key={assessment.questionIdx + '-' + choiceIndex}
                                                                    >
                                                                        <div className='mt-1'>
                                                                            <div className='flex flex-v-center'>
                                                                                <span className='mr-1'>{choiceLetter}.</span>
                                                                                <div style={{ width: '32px', height: '32px' }}
                                                                                    className='br-4 border mr-2'></div>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className='flex assessment-radio p-2 border br-4 w-100'
                                                                            value={choiceIndex}
                                                                            size='large'
                                                                        >
                                                                            <div className='flex ml-05 p-mb-0 white-space-normal'>
                                                                                <DocumentDelegator
                                                                                    document={{
                                                                                        components: choice.choice,
                                                                                        assessment: assessment,
                                                                                        metadata: currentQuestion.metadata
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            })}
                                </div>
                            </div>}
                    </div>
                </Modal>
            </div>
        )
    }
}

export default PrintableAssessmentModal
